import _ from 'lodash';
import browser from 'bowser';
import modernizr from '../vendor/modernizr.custom';
import config from '../config';
import ip from 'ip';
import StringConstants from '../constants/StringConstants';

const EXTRA_SMALL_MOBILE_VIEW = 480;

const BrowserUtils = {
  isDateInputType() {
    return modernizr.inputtypes.date;
  },
  isMobileBrowser() {
    return modernizr.touch && (browser.mobile || browser.tablet);
  },
  isMobileView() {
    const screenSize = BrowserUtils.getScreenSize();
    const screenWidth = screenSize ? screenSize.x : undefined;
    const isMobileDevice = screenWidth < 801;
    return isMobileDevice;
  },
  getClientIp() {
    return ip.address();
  },

  getUserAgent() {
    return navigator.userAgent || navigator.vendor || window.opera;
  },

  getPlatform() {
    return navigator.platform || window.opera;
  },

  getBrowserVersion() {
    return navigator.appVersion || navigator.vendor || window.opera;
  },

  getBrowserName() {
    return `${navigator.appName} - ${navigator.appCodeName}` || window.opera;
  },

  getUserLocale() {
    return (
      navigator.userLanguage ||
      navigator.language ||
      navigator.browserLanguage ||
      navigator.systemLanguage
    );
  },

  getScreenSize() {
    const w = window;
    const d = document;
    const e = d.documentElement;
    const g = d.getElementsByTagName('body')[0];
    const x = w.innerWidth || e.clientWidth || g.clientWidth;
    const y = w.innerHeight || e.clientHeight || g.clientHeight;

    return { x, y };
  },

  /**
   * Determine if this is a compatible browser
   *
   * @return {bool}       True if this is a compatible browser
   */
  isCompatible() {
    let compatible = false;

    // Don't check browser and version on mobile or tablet
    if (browser.mobile || browser.tablet) {
      return true;
    }

    // Do check the compatible browsers list in config
    _.each(config.compatibleBrowsers, (compatibleBrowser) => {
      if (
        browser[compatibleBrowser.browser] &&
        parseInt(browser.version) >= compatibleBrowser.version
      ) {
        compatible = true;
      }
    });

    if (process.env.NODE_ENV === 'development') {
      compatible = true;
    }

    return compatible;
  },

  /**
   * Set viewport to scale 0 or 1 for zoom functionality
   *
   */
  setViewPort(scale) {
    const viewport = document.querySelector('meta[name=viewport]');
    // is it already set to initial-scale=0
    const initialScale =
      viewport.getAttribute('content').search('initial-scale=0') > 0;
    if (scale === 0 && (this.getScreenSize().x < 991 || initialScale)) {
      viewport.setAttribute('content', 'width=1024, initial-scale=0');
    } else {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1');
    }
  },

  isTabletLanscapeView() {
    const screenSize = BrowserUtils.getScreenSize();
    const screenWidth = screenSize ? screenSize.x : undefined;
    const isTabletDevice = screenWidth < 1025;
    return isTabletDevice;
  },

  isTabletView() {
    const screenSize = BrowserUtils.getScreenSize();
    const screenWidth = screenSize ? screenSize.x : undefined;
    const isTabletDevice = screenWidth < 960;
    return isTabletDevice;
  },
  // Here 1 is mobile view,2 is tablet view,3 is desktop view
  getDevice() {
    if (this.isMobileView()) {
      return StringConstants.VIEW_MOBILE;
    } else if (this.isTabletView()) {
      return StringConstants.VIEW_TABLET;
    } else {
      return StringConstants.VIEW_DESKTOP;
    }
  },
  isMobileViewNew() {
    const screenSize = BrowserUtils.getScreenSize();
    const screenWidth = screenSize ? screenSize.x : undefined;
    const isMobileDevice = screenWidth < 600;
    return isMobileDevice;
  },
  isExtraSmallMobileView() {
    const screenSize = BrowserUtils.getScreenSize();
    return screenSize?.x < EXTRA_SMALL_MOBILE_VIEW;
  },
  getView() {
    if (this.isMobileViewNew()) {
      return 'mobile';
    } else if (this.isTabletView()) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  },
  windowScrollTop() {
    const docElemProp = window.document.documentElement.clientTop;
    const body = window.document.body;
    return (
      (window.document.compatMode === 'CSS1Compat' && docElemProp) ||
      (body && body.clientTop) ||
      docElemProp
    );
  },
  elementOffset(element) {
    const de = document.documentElement;
    const box = element.getBoundingClientRect();
    const top = box.top + window.pageYOffset - de.clientTop;
    const left = box.left + window.pageXOffset - de.clientLeft;
    return { top, left };
  },
  getPosition(element) {
    let xPos = 0;
    let yPos = 0;
    let el = element;
    if (el) {
      while (el) {
        if (el.tagName === 'BODY') {
          const xScroll = el.scrollLeft || document.documentElement.scrollLeft;
          const yScroll = el.scrollTop || document.documentElement.scrollTop;
          xPos += el.offsetLeft - xScroll + el.clientLeft;
          yPos += el.offsetTop - yScroll + el.clientTop;
        } else {
          xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
          yPos += el.offsetTop - el.scrollTop + el.clientTop;
        }
        el = el.offsetParent;
      }
    }
    return {
      x: xPos,
      y: yPos,
    };
  },
  isFocusableElement(tag) {
    const condtition1 =
      ['a', 'li', 'button', 'input', 'select', 'options'].indexOf(
        String(tag.tagName).toLowerCase()
      ) !== -1;
    const condition2 = tag.tabIndex >= 0;
    return condtition1 || condition2;
  },
  isEligibleKeyDownCode(keyPressed = 0) {
    if ([9, 40, 38, 13, 32].indexOf(keyPressed) !== -1) {
      return true;
    } else {
      return false;
    }
  },
  isIEOrEdgeBrowser() {
    return /* @cc_on!@*/ false || !!document.documentMode;
  },
};

export default BrowserUtils;
